module.exports = function() {
  return new Worker(__webpack_public_path__ + "f308c67ec95b51248193.worker.js");
};